import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebButtonComponent } from './web-button.component';

@NgModule({
    declarations: [WebButtonComponent],
    imports: [CommonModule],
    exports: [WebButtonComponent],
})
export class WebButtonModule {}
